"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SummaryOfChargesFooter = _interopRequireDefault(require("../SummaryOfChargesFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function SummaryOfChargesPayNow(_ref) {
  var className = _ref.className,
      payNowAmount = _ref.payNowAmount,
      currencySymbol = _ref.currencySymbol,
      currencyCode = _ref.currencyCode,
      payNowFootNote = _ref.payNowFootNote,
      onLookupPage = _ref.onLookupPage;
  var title = onLookupPage ? 'What you have paid' : 'What you pay now';
  return _react["default"].createElement(_SummaryOfChargesFooter["default"], {
    title: title,
    className: className,
    amount: payNowAmount,
    prefixText: currencySymbol,
    suffixText: currencyCode,
    footnoteSymbol: payNowFootNote,
    backgroundColor: "#FFF",
    textColor: "#000"
  });
}

SummaryOfChargesPayNow.displayName = 'SummaryOfChargesPayNow';
SummaryOfChargesPayNow.propTypes = {
  className: _propTypes["default"].string,
  payNowAmount: _propTypes["default"].number.isRequired,
  currencySymbol: _propTypes["default"].string,
  currencyCode: _propTypes["default"].string,
  payNowFootNote: _propTypes["default"].string,
  onLookupPage: _propTypes["default"].bool
};
SummaryOfChargesPayNow.defaultProps = {
  className: '',
  currencySymbol: '$',
  currencyCode: 'USD',
  onLookupPage: false
};

var _default = (0, _react.memo)(SummaryOfChargesPayNow);

exports["default"] = _default;